function r(n) {
  return n != null && typeof n["@@transducer/step"] == "function";
}
export {
  r as default
};
